import { render } from "./HomeTaiKang.vue?vue&type=template&id=0a4e0ec8&scoped=true"
import script from "./HomeTaiKang.vue?vue&type=script&lang=js"
export * from "./HomeTaiKang.vue?vue&type=script&lang=js"

import "./HomeTaiKang.vue?vue&type=style&index=0&id=0a4e0ec8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a4e0ec8"]])

export default __exports__